import { render, staticRenderFns } from "./AppFooterContact.vue?vue&type=template&id=5ad024be&scoped=true&"
import script from "./AppFooterContact.ts?vue&type=script&lang=ts&"
export * from "./AppFooterContact.ts?vue&type=script&lang=ts&"
import style0 from "./AppFooterContact.scss?vue&type=style&index=0&id=5ad024be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad024be",
  null
  
)

export default component.exports